import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import DataManage from './data_manage'
import DataMangeDetail from './data_manage_detail'
import Statistics from './statistics'
export default class index extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route exact path={`${match.url}/data_manage`} component={DataManage} />
        <Route path={`${match.url}/data_manage/:id`} component={DataMangeDetail} />
        <Route path={`${match.url}/statistics`} component={Statistics} />
        <Redirect from="*" to={`${match.url}/data_manage`} />
      </Switch>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/index.js